import { createClient } from '@/lib/supabase/client';

interface LineItem {
  description: string;
  qty: number;
  unit: string;
  rate: number;
}

interface SendQuoteEmailParams {
  to: string;
  clientName: string;
  refNumber: string;
  lineItems: LineItem[];
  subtotal: number;
  gst: number;
  total: number;
  validDays: string;
  additionalNotes?: string;
  serviceCategory: string;
}

interface SendJobAssignmentEmailParams {
  to: string;
  clientName: string;
  refNumber: string;
  scheduledDate?: string;
  scheduledTime?: string;
  teamName?: string;
  propertyAddress?: string;
}

async function invokeEmailFunction(payload: Record<string, unknown>): Promise<void> {
  const supabase = createClient();
  const { error } = await supabase.functions.invoke('send-email', {
    body: payload,
  });
  if (error) {
    console.error('Email send error:', error.message);
    throw error;
  }
}

export async function sendQuoteConfirmationEmail(params: SendQuoteEmailParams): Promise<void> {
  await invokeEmailFunction({
    type: 'quote_confirmation',
    to: params.to,
    clientName: params.clientName,
    refNumber: params.refNumber,
    lineItems: params.lineItems,
    subtotal: params.subtotal,
    gst: params.gst,
    total: params.total,
    validDays: params.validDays,
    additionalNotes: params.additionalNotes || '',
    serviceCategory: params.serviceCategory,
  });
}

export async function sendJobAssignmentEmail(params: SendJobAssignmentEmailParams): Promise<void> {
  await invokeEmailFunction({
    type: 'job_assignment',
    to: params.to,
    clientName: params.clientName,
    refNumber: params.refNumber,
    scheduledDate: params.scheduledDate || '',
    scheduledTime: params.scheduledTime || '',
    teamName: params.teamName || '',
    propertyAddress: params.propertyAddress || '',
  });
}
